module.exports = __webpack_public_path__ + "img/mobilepromo.a2bc0cb2.png";